import { render, staticRenderFns } from "./MouvementTable.vue?vue&type=template&id=620abe54"
import script from "./MouvementTable.vue?vue&type=script&lang=js"
export * from "./MouvementTable.vue?vue&type=script&lang=js"
import style0 from "./MouvementTable.vue?vue&type=style&index=0&id=620abe54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports